module.exports = new __parcel__URL__("CineBriqueVF.77fe7595.jpeg").toString();